import configs from "config";

const coinMap = configs.coins;

// console.log("COIN MAP", coinMap);

type utilsMapType = Partial<{
  enactPrecision: (...args: any[]) => number;
  enactPrecisionWithUnit: (...args: any[]) => string;
  enactUnit: (...args: any[]) => string | number;
}>;

const isSupported = (coin: string) => Object.keys(coinMap).includes(coin);

const toPrecision = (number: number, coin: string, showUnit = true, precision = 8, forcePrecisionParam = false) => {
  const utilsMap: utilsMapType = {
    enactPrecision: (_precision: number) => normaliseExponents(Number(Number(number).toFixed(_precision))),
    enactPrecisionWithUnit: (_precision: number, _coin: string) =>
      `${normaliseExponents(Number(Number(number).toFixed(_precision)))} ${String(_coin)}`,
  };

  utilsMap.enactUnit = (_precision, _coin) =>
    showUnit ? utilsMap?.enactPrecisionWithUnit!(_precision ?? precision, _coin) : utilsMap?.enactPrecision!(_precision);

  if (!isSupported(coin)) return utilsMap.enactUnit(precision, String(coin).toUpperCase());

  return utilsMap.enactUnit(forcePrecisionParam ? precision : (coinMap as any)[coin]?.precision, (coinMap as any)[coin].label);
};

export const getCoinPrecision = (coin: string, defaultPrecision = 8) => {
  return (coinMap as any)[coin]?.precision ?? defaultPrecision;
};

export const toNumPrecision = (number: number | string, precision: number = 2) => {
  const num = Number(number);
  return Number(num.toFixed(precision));
};

// MathRound(3.256, 2) => 3.25 gives instead of 3.26
export const MathRound = (num: number, nrdecimals: number) => {
  let n = Number(Number(num).toFixed(nrdecimals));
  return n > num ? toNumPrecision(n - 1 / Math.pow(10, nrdecimals), nrdecimals) : n;
};

export default toPrecision;

function normaliseExponents(value: number) {
  let x: any = value;
  if (Math.abs(x) < 1.0) {
    let e = parseInt(x.toString().split("e-")[1]);
    if (e) {
      x *= Math.pow(10, e - 1);
      x = "0." + new Array(e).join("0") + x.toString().substring(2);
    }
  } else {
    let e = parseInt(x.toString().split("+")[1]);
    if (e > 20) {
      e -= 20;
      x /= Math.pow(10, e);
      x += new Array(e + 1).join("0");
    }
  }
  return x;
}

export const addCommas = (num: number | string) => {

  const [integer, decimal] = Number(num).toString().split(".");

  const withComma = parseInt(integer, 10).toLocaleString();

  const result = `${withComma}.${decimal || "0"}`;

  return result;
};
